import { Component, Inject, ElementRef,ViewChild, Optional, OnInit,Injectable } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilsService } from '../../../services/utils.service';
import { MarcoDeReferenciaService } from '../../../services/marco-de-referencia.service';
import { MarcoDeReferencia } from 'app/main/models/marco-de-referencia.model';
import { Sentencia } from 'app/main/models/sentencia.model';
import { MatTable } from '@angular/material/table';
import { DialogBoxChangeTreeComponent } from './dialog-box-change-tree.component';

import {SelectionModel} from '@angular/cdk/collections';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {BehaviorSubject} from 'rxjs';

import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { first } from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';


interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  //descripcion: string;
  level: number;
}

interface TodoItemFlatNode {
  valor: Sentencia;
  nombre: string;
  level: number;
  expandable: boolean;
  editable: boolean;
}

interface NodoFlat{
  key: TodoItemFlatNode;
  value: any;
}


@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box-change-father.component.html',
  styleUrls: ['./dialog-box-change-father.component.scss']
})
export class DialogBoxChangeFatherComponent {

  action: string;
  LOCAL_DATA: any;



  private _transformer = (node: Sentencia, level: number) => {
    return {
      expandable: !!node.sentencias && node.sentencias.length > 0,
      name: node.nombre,
      descripcion: node.descripcion,
      level: level
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(
      node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.sentencias);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  dataSourceList = [];
  flatNodeMap = new Map<TodoItemFlatNode, MarcoDeReferencia>();

  @ViewChild('tipoInput') tipoInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild(MatTable, {static: true}) table: MatTable<any>;

  constructor(
    public dialog: MatDialog,
    public translate: TranslateService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogBoxChangeFatherComponent>,
    public serviceEstructura:MarcoDeReferenciaService,
    public utils:UtilsService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.dialogRef.disableClose = true;
    this.LOCAL_DATA = {...data.obj};
    this.dataSource.data = [...data.dataSource.data];
    this.flatNodeMap = data.flatNodeMap;

    this.action = data.action;
  }

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {

  }

  selectNode(node): void {
    const destino = this.findNode(node);
    const dialogRef = this.dialog.open(DialogBoxChangeTreeComponent, {
      width: '100%',
      data: {nodo:this.LOCAL_DATA,destino:destino,action:'Update'},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

      this.dialogRef.close({event: 'Update'});

    });
  }

  toRootItem(){
    const destino = {"nombre":"Raiz",id:null};
    const dialogRef = this.dialog.open(DialogBoxChangeTreeComponent, {
      width: '100%',
      data: {nodo:this.LOCAL_DATA,destino:destino,action:'Update'},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

      this.dialogRef.close({event: 'Update'});

    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  orderStructure(nodos):void{

    for(var z=0; nodos.length>z;z++){
      nodos.sort(this.utils.sortAlphaNum);
      this.orderStructure(nodos[z].sentencias);
    }
  }

  findNode(node):any{
    var selected = null;
    this.flatNodeMap.forEach(element => {
      if(element.nombre == node.name)
         selected = element;
    });
    return selected;
  }



}
